module.exports = __webpack_public_path__ + "img/img_target_right_bf.71aab46e.svg";